import React, { useContext, useEffect, useState } from "react";
import OTPComponent from "../otp/OTPComponent";
import useOTP from "../../hooks/OTPhook";
import useManualUpload from "../../hooks/ManualUploadhook";
import Timer from "../TimerComponent";
import { GenerateOtp, validatePassword } from "../../api/FetchAPI";
import SecretQuestion from "../secretquestion/SecretQuestion";
import Button from "../button/Button";
import { AuthContext } from "../AuthContextComponent";
import { useNavigate } from "react-router-dom";
import {
  generateLoading,
  stopLoading,
} from "../../promptMessages/PromptMessages";
import TextArea from "../textfield/TextArea";
import ReprocessModal from "../reprocess/ReprocessModal";
import useUserLogin from "../../hooks/UserLoginhook";

interface ModalProps {
  data?: any;
  footer?: string;
  header?: string;
  isClose: boolean;
  label?: string;
  transType?: string;
  type?: string;
  setOpenOTP?: any;
  userId: string;
  otpTimer: number;
  otpType: string;
  reset?: any;
  sendType?: string;
  toggleClose?: any;
  invalidOTP?: boolean;
  questions?: any[];
  userData?: any;
  setOTP?: any;
  batchNumber?: any;
  onClick?: () => void;
  modalClose?: any;
  GetForApproval?: any;
  setApprovalStatus?: any;
  isDone?: (value: boolean) => void;
  isGenerating?: (value: boolean) => void;
  isReprocessData?: (value: any) => void;
  isTotalDisplay?: (value: any) => void;
  selectedRows?: any;
}

const Modal = ({
  footer,
  header,
  isClose,
  label,
  type,
  data,
  transType,
  setOpenOTP,
  userId,
  otpTimer,
  otpType,
  reset,
  sendType,
  toggleClose,
  invalidOTP,
  questions,
  userData,
  batchNumber,
  modalClose,
  onClick,
  GetForApproval,
  setApprovalStatus,
  isDone,
  isGenerating,
  isReprocessData,
  isTotalDisplay,
  selectedRows,
}: // setOTP,
ModalProps) => {
  const userInfo = useContext(AuthContext);
  const [hasOpened, setHasOpened] = useState(false);
  const [currentOtpTimer, setCurrentOtpTimer] = useState(otpTimer);
  const { otp, otps, handleChange, handleKeyDown, handlePaste, setOTP } =
    useOTP();
  const [isOpen, setIsOpen] = useState(false);
  const { generateotp } = useManualUpload();
  const { textColorClass, customColor } = useUserLogin();
  const naviagte = useNavigate();
  const backgroundColor = userInfo.userInfo?.theme === "DARK" ? "#2b3137" : "";
  const themeBackground = userInfo.userInfo?.theme === "DARK" ? "#24292e" : "";
  const themeTextColor = userInfo.userInfo?.theme === "DARK" ? "#fafbfc" : "";
  const toggleChange = () => {
    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
  };

  useEffect(() => {
    if (!hasOpened) {
      toggleChange();
      setHasOpened(true);
      setCurrentOtpTimer(otpTimer);
    }
  }, [hasOpened]);

  const handleTimerFinish = (setOTP: any) => {
    setCurrentOtpTimer(0); // Set timer to 0 when finished
    setOTP(new Array(6).fill(""));
  };

  const handleResend = async () => {
    if (currentOtpTimer === 0) {
      const response: any = await GenerateOtp(userId, otpType);
      setCurrentOtpTimer(response.seconds);
      // setCurrentOtpTimer(10);
    }
  };

  const handleRedirectSecurityQuestion = () => {
    generateLoading("Redirecting...", themeBackground, themeTextColor);
    setTimeout(() => {
      stopLoading();
      naviagte("/paymentsolution/profile/secret-question");
    }, 1500);
  };

  const handleRedirectUpdatePassword = () => {
    generateLoading("Redirecting...", themeBackground, themeTextColor);
    setTimeout(() => {
      stopLoading();
      naviagte("/paymentsolution/profile/change-password");
    }, 1500);
  };

  return (
    <>
      {isOpen && (
        <div
          className={`fixed inset-0 bg-black transition-all duration-1000 ease-in-out mx-auto px-4 ${
            userInfo.userInfo?.theme === `DARK` ? `text-white` : `text-black`
          }  bg-opacity-50 flex justify-center items-center z-50 font-sans`}
        >
          <div
            className="bg-white rounded-lg shadow-lg p-10 min-w-2.5 max-w-[1240px] px-4"
            style={{ backgroundColor }}
          >
            <div className="flex justify-between items-center mx-auto px-4 ">
              <h2 className="md:text-custom-standard text-custom-petite font-semibold w-full">
                {header}
              </h2>
              {transType === "loginOTP" ? (
                " "
              ) : transType === "redirect" ? (
                " "
              ) : transType === "redirectChangePassword" ? (
                " "
              ) : (
                <button
                  className="text-gray-500 text-2xl"
                  onClick={toggleClose}
                >
                  &times;
                </button>
              )}
            </div>
            <div
              className={`flex justify-center  ${
                type === "OTP" ? "mt-10" : ""
              }`}
            >
              <label className="md:text-custom-petite text-custom-micro w-full text-center mx-auto px-4 py-2">
                {label}
              </label>
            </div>

            <div className="p-10 flex justify-center">
              {type === "OTP" && (
                <OTPComponent
                  label={
                    sendType
                      ? "An OTP has been sent to your Email to validate your request."
                      : "An OTP has been sent to your SMS to validate your request."
                  }
                  otps={otps}
                  otp={otp}
                  data={data}
                  type={transType}
                  isClose={isClose}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  onPaste={handlePaste}
                  setOpenOTP={setOpenOTP}
                  userId={userId}
                  userData={userData}
                  reset={reset}
                  setOTP={setOTP}
                />
              )}
              {type === "ForgetPassword" && (
                <SecretQuestion
                  questions={questions}
                  userId={userId}
                  setIsOpen={setOpenOTP}
                ></SecretQuestion>
              )}
              {type === "REDIRECT" ? (
                <>
                  <div className="flex flex-col gap-14">
                    <label className="md:text-custom-petite text-custom-micro">
                      Hold on there!
                      <br />
                      <br />
                      It looks like you're almost there!
                      <br />
                      Before we proceed, let’s set up your security questions.
                      <br />
                      Think of them as your personal secret handshake! <br />
                      <br />
                      Ready to add a little mystery? <br />
                      Click the button below to secure your secrets!
                    </label>

                    <Button
                      label="Redirect"
                      width="full"
                      rounded
                      variant="btn-danger"
                      onClick={handleRedirectSecurityQuestion}
                      customColor={customColor}
                    ></Button>
                  </div>
                </>
              ) : (
                <></>
              )}
              {type === "UPDATE" ? (
                <>
                  <div className="flex flex-col gap-10">
                    <label className="md:text-custom-petite text-custom-micro">
                      Important: First-Time Login
                      <br />
                      <br />
                      For your security, please update your password during your
                      first login. <br />
                      <br />
                      Click the button below to update your password!
                    </label>

                    <Button
                      label="Redirect"
                      rounded
                      variant="btn-danger"
                      onClick={handleRedirectUpdatePassword}
                      customColor={customColor}
                    ></Button>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
            {type === "OTP" ? (
              <>
                <div className="mt-5 w-full">
                  <Timer
                    key={currentOtpTimer}
                    duration={currentOtpTimer}
                    onFinish={() => handleTimerFinish(setOTP)}
                  />
                </div>
                <div className="flex md:text-custom-petite text-custom-micro justify-center mt-5">
                  {invalidOTP ||
                    (currentOtpTimer === 0 && (
                      <>
                        {footer}
                        <button className=" ml-1" onClick={handleResend}>
                          <label
                            htmlFor=""
                            style={{ color: textColorClass }}
                            className="ml-2 cursor-pointer text-custom-default-hover hover:text-black transform md:text-custom-petite text-custom-micro"
                          >
                            Resend
                          </label>
                        </button>
                      </>
                    ))}
                </div>
              </>
            ) : (
              ""
            )}

            {type === "REJECT" ? (
              <div className="flex flex-col gap-5 -mt-12 items-center">
                <TextArea
                  batchNumber={batchNumber}
                  modalClose={modalClose}
                  GetForApproval={GetForApproval}
                  setApprovalStatus={setApprovalStatus}
                ></TextArea>
              </div>
            ) : (
              ""
            )}

            {type === "REPROCESS" ? (
              <div className="flex flex-col gap-5 -mt-12 items-center">
                <ReprocessModal
                  data={data}
                  modalClose={modalClose}
                  batchNumber={batchNumber}
                  isDone={isDone}
                  isGenerating={isGenerating}
                  isReprocessData={isReprocessData}
                  isTotalDisplay={isTotalDisplay}
                  selectedRows={selectedRows}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
